// extracted by mini-css-extract-plugin
module.exports = {"form":"SubscriptionBlock_form__KiOOT","input":"SubscriptionBlock_input__hR5P5"};